import React from 'react';

import { SocialIconStyles } from '../SelectIcon';

export const component = ({
  color = '#fff',
  origin = '',
  customStyle = null,
}) => (
  <svg
    style={origin === 'header menu' ? SocialIconStyles : customStyle}
    aria-label="Whatsapp Icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 308 308"
  >
    <path
      fill={color}
      d="M227.9 177c-.6-.3-23-11.4-27-12.8-1.7-.6-3.4-1.2-5.3-1.2-3 0-5.5 1.6-7.5 4.5a208 208 0 0 1-12 14.4l-4.8-2c-24-10.4-42.3-35.6-44.8-39.8-.4-.6-.4-.9-.4-.9 0-.3.9-1.1 1.3-1.5l3.8-4.4 1.8-2.1c1.9-2.2 2.7-3.9 3.7-5.8l.5-1c2.3-4.7.3-8.6-.3-9.9l-11-26.3c-2.5-5.9-5.7-8.6-10.1-8.6l-1.7.1c-2.2.1-13.6 1.6-18.7 4.8C90 88 80.9 98.7 80.9 117.8c0 17.1 10.9 33.3 15.5 39.4l.7 1c17.8 26 40.1 45.4 62.7 54.4 21.8 8.7 32 9.7 37.9 9.7 2.5 0 4.4-.2 6.2-.4h1c7.6-.7 24-9.3 27.8-19.7 3-8.2 3.8-17.2 1.8-20.5-1.3-2.2-3.7-3.3-6.6-4.7z"
    />
    <path
      fill={color}
      d="M156.7 0A150.9 150.9 0 0 0 5.5 150.1c0 26.8 7.1 53 20.7 76l-26 76.6a4 4 0 0 0 5 5.1l80-25.4a152.3 152.3 0 0 0 71.5 17.9c83.4 0 151.3-67.4 151.3-150.2C308 67.4 240.1 0 156.7 0zm0 269c-23.5 0-46.3-6.8-65.9-19.7a4 4 0 0 0-3.4-.4l-40 12.7 12.9-38.1a4 4 0 0 0-.6-3.7A117.2 117.2 0 0 1 37 150.1C37 84.6 90.7 31.3 156.7 31.3c66.1 0 119.8 53.3 119.8 118.8 0 65.6-53.7 118.9-119.8 118.9z"
    />
  </svg>
);

export default component;



// WEBPACK FOOTER //
// ./src/components/UI/Img/SocialIconsSVG/Whatsapp.jsx